import { DirectiveBinding, ref } from 'vue'

interface DirectiveOptions {
  delay?: number
  timeBetween?: number
  class?: string
}

export default function useFadeInDirective() {
  const duration = ref(300)
  const timeout = ref(100)
  const _class = ref('lp-load-fadein')

  const fadeIn = (el: HTMLElement) => {
    const elementsToFade = el.querySelectorAll(`.${_class.value}`)

    elementsToFade.forEach((element, i) => {
      setTimeout(() => {
        element.animate(
          {
            translate: `0 0`,
            opacity: `1`,
          },
          { duration: duration.value, fill: 'forwards' },
        )
      }, i * timeout.value)
    })
  }

  const observerCallback: MutationCallback = (mutationsList) => {
    for (const mutation of mutationsList) {
      if (mutation.type === 'childList' && mutation.addedNodes.length) {
        fadeIn(mutation.target as HTMLElement)
      }
    }
  }

  const observer = new MutationObserver(observerCallback)

  return {
    created(el: HTMLElement, bindings: DirectiveBinding<DirectiveOptions>) {
      const options = bindings.value
      const { delay, timeBetween } = options ?? {}

      if (delay) {
        duration.value = delay
      }

      if (timeBetween) {
        timeout.value = timeBetween
      }

      if (options?.class) {
        _class.value = options.class
      }
    },
    mounted(el: HTMLElement) {
      fadeIn(el)
      observer.observe(el, { childList: true, subtree: true })
    },
    updated(el: HTMLElement) {
      fadeIn(el)
    },
    beforeUnmount() {
      observer.disconnect()
    },
  }
}
